import { render, staticRenderFns } from "./CRTask.vue?vue&type=template&id=2e0389e6&scoped=true&"
import script from "./CRTask.vue?vue&type=script&lang=js&"
export * from "./CRTask.vue?vue&type=script&lang=js&"
import style0 from "./CRTask.vue?vue&type=style&index=0&id=2e0389e6&prod&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0389e6",
  null
  
)

export default component.exports